import fetchCategoryPathsSlug from "common/fetch/fetchCategoryPathsSlug";
import fetchSeo from "common/fetch/fetchSeo";
import getRelatedPostAndCustomContent from "common/fetch/getRelatedPostAndCustomContent";
import getClientLocale from "common/fetch/gqlQueryByFetch";

import Layout from "components/common/Layout";
import Post from "components/templates/common/post";

import dataJson from "./data.json";

const specialBLogs = [
  "offshore-company-and-how-it-works",
  "how-to-choose-business-structure",
  "economic-substance-rules",
  "starting-an-online-business-in-the-uk-for-beginners",
  "steps-to-registering-a-company",
  "best-offshore-company-jurisdictions",
];
const haveEbook = ["offshore-company-and-how-it-works"];
const hiddenFeatureImgBlogs = [
  "/economic-substance-rules",
  "/starting-an-online-business-in-the-uk-for-beginners",
  "/offshore-company-and-how-it-works",
  "/steps-to-registering-a-company",
  "/how-to-choose-business-structure",
  "/a-guide-to-bvi-economic-substance-requirements",
  "/benefits-of-offshore-bank-accounts",
  "/best-offshore-company-jurisdictions",
];

export default function Home({ data }) {
  return (
    <div>
      <Layout locationRouter="offshore" page={data?.page.seo_string}>
        <Post
          data={data}
          dataJson={dataJson}
          specialLayout={specialBLogs.some((item) =>
            data.post.uri.includes(item)
          )}
          haveEbook={haveEbook.some((item) => data.post.uri.includes(item))}
          hiddenFeatureImg={hiddenFeatureImgBlogs.some((item) =>
            data.post.uri.includes(item)
          )}
        />
      </Layout>
    </div>
  );
}
export const getStaticPaths = async () => {
  const posts = await fetchCategoryPathsSlug({
    name: "articles",
    locale: "offshore",
  });

  return {
    paths: [].concat(posts),
    fallback: false, // Static
    // Fallback: "blocking", // ssg
  };
};

export const getStaticProps = async ({ params }) => {
  const locale = "offshore";
  const category = "articles";
  const slug = params?.slug[0];

  const page = await fetchSeo({
    uri: `/${category}/${slug}`,
    locale,
    getSeoString: true,
  });
  const post = await getClientLocale(locale).query({
    variables: {
      slug,
    },
    query: `
      query theQuery($slug: String!) {
        postBy(slug: $slug) {
          databaseId
          title
          author {
            node {
              name
            }
          }
          uri
          date
          categories {
            nodes {
              name
              uri
              parent {
                node {
                  id
                }
              }
            }
          }
          tags {
            nodes {
              databaseId
              name
            }
          }
          content
          featuredImage {
            node {
              sizes(size: LARGE)
              sourceUrl(size: LARGE)
              srcSet(size: LARGE)
              mediaDetails {
                width
                height
                sizes {
                  name
                  sourceUrl
                  width
                  height
                }
              }
              altText
            }
          }
          tableOfContents
          parts {
            parts {
              ... on Post {
                title
                uri
                date
                excerpt
                categories {
                  nodes {
                    name
                    uri
                    parent {
                      node {
                        id
                      }
                    }
                  }
                }
                featuredImage {
                  node {
                    sizes(size: THUMBNAIL)
                    sourceUrl(size: THUMBNAIL)
                    srcSet(size: THUMBNAIL)
                    mediaDetails {
                      width
                      height
                      sizes {
                        name
                        sourceUrl
                        width
                        height
                      }
                    }
                    altText
                  }
                }
              }
            }
          }
          faqs {
            faqs {
              name
              content
            }
          }
        }
      }
    `,
  });

  const data_posts = await getRelatedPostAndCustomContent({
    post,
    category,
    locale,
  });

  return {
    props: {
      data: {
        page: page || [],
        post: {
          ...post?.data?.postBy,
          content: data_posts.custom_content,
        },
        relatedPosts: data_posts.related_posts || [],
        recentPosts:
          [...data_posts.country_posts, ...data_posts.recent_posts] || [],
      },
      revalidate: 1,
    },
  };
};
